const KatalLoggerApiConfig = new Map([
    [
        'dev',
        {
            ENDPOINT: '', // Modify this to use dev KatalLogger API endpoint
        },
    ],
    [
        'beta',
        {
            ENDPOINT: 'https://n3ezhhgwlb.execute-api.us-east-1.amazonaws.com/prod/v1/log',
        },
    ],
    [
        'prod',
        {
            ENDPOINT: 'https://wr2snu5xqh.execute-api.us-east-1.amazonaws.com/prod/v1/log',
        },
    ],
]);
export default KatalLoggerApiConfig;
//# sourceMappingURL=KatalLoggerConfig.js.map